import React from "react";

import ContentCore from "../../../core/workingContent";

const TaskListLate = () => {
  return (
    <ContentCore />
  )
}

export default TaskListLate